import React, { useState, useEffect } from 'react'
import icon from '../assets/icon.png'
import { Link } from 'react-router-dom'

export default function Header() {
  const [scroll, setScroll] = useState(false);

  const handleScroll = () => {
    if (window.pageYOffset > 70) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`fixed z-10 w-full flex justify-between items-center p-3 max-lg:p-1  ${scroll ? 'bg-[#F0F0F0]' : ''} px-20 `}>
      <Link to={'/'} className='flex items-center gap-2'>
        <img src={icon} alt="" width={'50px'} className='select-none' />
        <p className='text-2xl font-semibold'>Last Car Zone</p>
      </Link>

      <div className="flex gap-5 max-md:hidden">
        <Link to={'/cars'} className="font-semibold hover:-translate-y-0.5 duration-300">About</Link>
        <Link to={'/cars'} className="font-semibold hover:-translate-y-0.5 duration-300">Contact</Link>
        <Link to={'/collection'} className="font-semibold hover:-translate-y-0.5 duration-300">Collection</Link>
        <Link to={'/cars'} className="font-semibold hover:-translate-y-0.5 duration-300">Orders</Link>
        <div className="mx-1 divider divider-horizontal"></div>
        <Link to={'/cars'} className="font-semibold hover:-translate-y-0.5 duration-300">LogIn</Link>
      </div>
      <div className="dropdown dropdown-end md:hidden">
        <label tabIndex={0} className="btn btn-ghost btn-circle avatar">
          <div className="w-10 rounded-full">
            <img src="https://www.nzherald.co.nz/resizer/sLDj54v6mBmfljZa9s1py-m9cJM=/576x613/filters:focal(1327x18:1903x632)/cloudfront-ap-southeast-2.images.arcpublishing.com/nzme/4B4ALEPEEVD3TN76KTWF43A5ZM.JPG" />
          </div>
        </label>
        <ul tabIndex={0} className="p-2 mt-3 shadow menu menu-compact dropdown-content bg-base-100 rounded-box w-52">
          <li>
            <a className="justify-between">
              Profile
              <span className="badge">New</span>
            </a>
          </li>
          <li><a>Settings</a></li>
          <li><a>Logout</a></li>
        </ul>
      </div>
    </div>
  )
}
